// Placeholder 360° frames for the e-bike interactive viewer.
//
// These are AI-generated stand-ins commissioned by the founder while
// real product photography is arranged with the manufacturer (Barry
// Peng / HK Nova / Eahora). They are 8 evenly-spaced angles around
// the bike: 0° · 45° · 90° · 135° · 180° · 225° · 270° · 315°.
//
// **How to swap in real product photography, per-product:**
// Add a `frames360` field to the product entry in
// `/app/frontend/src/data/catalog.js`. When the field is present,
// the viewer uses those frames; when it's absent, it falls back to
// this placeholder set.
//
// Example (in catalog.js):
//    frames360: [
//      '/products/juliet2-360/0.jpg',
//      '/products/juliet2-360/45.jpg',
//      ...
//    ],

export const DEFAULT_360_FRAMES = [
  'https://static.prod-images.emergentagent.com/jobs/5eb8a1d6-2566-4d81-8e6e-866d3368682e/images/4ca8277f9b95a7f1fe8920de60335e28a63dfe53b3c064dee0d62727544945be.jpeg', // 0
  'https://static.prod-images.emergentagent.com/jobs/5eb8a1d6-2566-4d81-8e6e-866d3368682e/images/33fb205362f7f7ae5488cb8f28c21f88f6f956721363ea761f91ad72f051b487.jpeg', // 45
  'https://static.prod-images.emergentagent.com/jobs/5eb8a1d6-2566-4d81-8e6e-866d3368682e/images/a6749317f0be1563787fe37159bf54d1d86312517bde35c0fc062d2843114278.jpeg', // 90
  'https://static.prod-images.emergentagent.com/jobs/5eb8a1d6-2566-4d81-8e6e-866d3368682e/images/9eeeddb4ff43608ee8277f2f5730507d12dc7334e4d7977fa0d00d832666affc.jpeg', // 135
  'https://static.prod-images.emergentagent.com/jobs/5eb8a1d6-2566-4d81-8e6e-866d3368682e/images/7ce97c8416a6b877cb6e1c408b95a1469e8f63ec6e3469f3f9cb1375924901ec.jpeg', // 180
  'https://static.prod-images.emergentagent.com/jobs/5eb8a1d6-2566-4d81-8e6e-866d3368682e/images/94c6d10199a1a623ff94883f9c2b5bf7046abef9ed743a0ba1e882e5b414b47a.jpeg', // 225
  'https://static.prod-images.emergentagent.com/jobs/5eb8a1d6-2566-4d81-8e6e-866d3368682e/images/7ec0b732ee09209c18cfa19bac02bc71dbb1a84036abd44668df5cd21f7af937.jpeg', // 270
  'https://static.prod-images.emergentagent.com/jobs/5eb8a1d6-2566-4d81-8e6e-866d3368682e/images/eebc646c7045000d2f53a91a973f234c8f84f9f02cd2d4efe4c82ff9cd4ee342.jpeg', // 315
];
